/**
 * Listas de domínio CENSEC — fonte única para CensecAto.vue e DetalhesAtoRegistrado.vue.
 * Dados fornecidos pela equipe de produto (COD-5376, comment-id 614714).
 */

export const naturezasEscritura = [
  {id: '1', nome: '1 - Acordo Extrajudicial'},
  {id: '4', nome: '4 - Alienação Fiduciária'},
  {id: '5', nome: '5 - Cessão'},
  {id: '6', nome: '6 - Compra e Venda'},
  {id: '10', nome: '10 - Confissão de Dívida ou Dação em Pagamento'},
  {id: '14', nome: '14 - Declaração'},
  {id: '15', nome: '15 - Declaratória de União Estável'},
  {id: '16', nome: '16 - Declaratória de União Estável Homoafetiva'},
  {id: '17', nome: '17 - Desapropriação'},
  {id: '20', nome: '20 - Dissolução de União Estável'},
  {id: '21', nome: '21 - Distrato'},
  {id: '22', nome: '22 - Doação'},
  {id: '23', nome: '23 - Emancipação'},
  {id: '24', nome: '24 - Hipoteca'},
  {id: '25', nome: '25 - Incorporação'},
  {id: '26', nome: '26 - Bem de Família'},
  {id: '28', nome: '28 - Locação'},
  {id: '30', nome: '30 - Pacto Antenupcial'},
  {id: '31', nome: '31 - Penhor'},
  {id: '33', nome: '33 - Promessa de Cessão de Direitos Aquisitivos'},
  {id: '34', nome: '34 - Quitação'},
  {id: '35', nome: '35 - Rerratificação'},
  {id: '36', nome: '36 - Reconhecimento de Paternidade'},
  {id: '38', nome: '38 - Registro de Chancela Mecânica'},
  {id: '39', nome: '39 - Remissão de Foro e Laudêmios'},
  {id: '43', nome: '43 - Sem Valor Declarado'},
  {id: '45', nome: '45 - Servidão'},
  {id: '46', nome: '46 - Usufruto (Reserva, Instituição e Renúncia)'},
  {id: '48', nome: '48 - Condomínio'},
  {id: '49', nome: '49 - Parcelamento'},
  {id: '50', nome: '50 - Sociedade e Fundações'},
  {id: '51', nome: '51 - Transação'},
  {id: '52', nome: '52 - Direito de Uso ou Superfície'},
  {id: '53', nome: '53 - Divisão'},
  {id: '54', nome: '54 - Fiança'},
  {id: '55', nome: '55 - Diretivas Antecipadas de Vontade'},
  {id: '56', nome: '56 - Conferência de Bens'},
  {id: '57', nome: '57 - Novação'},
  {id: '58', nome: '58 - Crédito com Garantia'},
  {id: '59', nome: '59 - Emissão de Cédula'},
  {id: '60', nome: '60 - Emissão de Debêntures'},
  {id: '61', nome: '61 - Revogação'},
  {id: '62', nome: '62 - Renúncia de Direitos Hereditários'},
  {id: '63', nome: '63 - Comodato ou Mútuo'},
  {id: '70', nome: '70 - Prestação de Serviços'},
  {id: '71', nome: '71 - Arrendamento Mercantil (Leasing)'},
  {id: '72', nome: '72 - Concessão de Domínio'},
  {id: '74', nome: '74 - Contrato de Namoro'},
  {id: '75', nome: '75 - Conciliação'},
  {id: '76', nome: '76 - Mediação'},
  {id: '77', nome: '77 - Afetação'},
  {id: '78', nome: '78 - Autocuratela'},
  {id: '79', nome: '79 - Declaratória com Diretivas de Curatela'},
  {id: '80', nome: '80 - Promessa de Compra e Venda'},
];

export const naturezasLitigio = [
  {id: '1', nome: '1 - Bancário'},
  {id: '2', nome: '2 - Concessionária de Água'},
  {id: '3', nome: '3 - Concessionária de Gás'},
  {id: '4', nome: '4 - Concessionária de Luz'},
  {id: '5', nome: '5 - Consumidor'},
  {id: '6', nome: '6 - Contrato'},
  {id: '7', nome: '7 - Empresarial'},
  {id: '8', nome: '8 - Família'},
  {id: '9', nome: '9 - Locação'},
  {id: '10', nome: '10 - Mobiliário'},
  {id: '11', nome: '11 - Previdência'},
  {id: '12', nome: '12 - Saúde'},
  {id: '13', nome: '13 - Seguro'},
  {id: '14', nome: '14 - Serviço Público'},
  {id: '15', nome: '15 - Sucessões'},
  {id: '16', nome: '16 - Telefonia'},
  {id: '17', nome: '17 - Transporte'},
  {id: '18', nome: '18 - Transporte - Avião'},
  {id: '19', nome: '19 - Transporte - Barco'},
  {id: '20', nome: '20 - Transporte - Metrô'},
  {id: '21', nome: '21 - Transporte - Ônibus'},
];

export const naturezasUsucapiao = [
  {id: '1', nome: '1 - Ordinária'},
  {id: '2', nome: '2 - Extraordinária'},
  {id: '3', nome: '3 - Especial Rural'},
  {id: '4', nome: '4 - Especial Urbana'},
  {id: '5', nome: '5 - Especial Familiar'},
];

export const responsaveis = [
  {id: '1', nome: 'Cônjuge 1'},
  {id: '2', nome: 'Cônjuge 2'},
  {id: '3', nome: 'Ambos Cônjuges'},
  {id: '4', nome: 'Outros'},
  {id: '5', nome: 'Sem Declaração'},
];

export const opcoesAcordo = [
  {id: 'SIM', nome: 'Sim'},
  {id: 'NAO', nome: 'Não'},
];
